"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldSubmitJoinRequest = void 0;
var MemberRole_1 = require("../../Member/MemberRole");
var accessRestriction_1 = require("../accessRestriction");
function shouldSubmitJoinRequest(group) {
    return !MemberRole_1.isAdmin(group) && accessRestriction_1.restrictedByAdmin(group);
}
exports.shouldSubmitJoinRequest = shouldSubmitJoinRequest;
//# sourceMappingURL=index.js.map